import { render, staticRenderFns } from "./certificateTemplate.vue?vue&type=template&id=3812b541&scoped=true"
import script from "./certificateTemplate.vue?vue&type=script&lang=js"
export * from "./certificateTemplate.vue?vue&type=script&lang=js"
import style0 from "./certificateTemplate.vue?vue&type=style&index=0&id=3812b541&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3812b541",
  null
  
)

export default component.exports